export default "__VITE_ASSET__CiLWIGdo__"